import { triggerJsonDownload } from "./localDataExport";

// #3568: save a JSON file to a place the scribe picks (a USB stick). Where the
// browser has the File System Access picker (Chrome, Edge) the scribe chooses
// the folder and we write the file ourselves. Elsewhere it falls back to a normal
// download.
//
// Resolves { proven: true } once the picker path has WRITTEN the file (the write
// and close succeeded, so the file exists where the scribe chose). The download
// fallback resolves { proven: false }: a browser download starts but the page
// cannot see it finish or land on the stick, so it is NOT proof. The caller must
// then make the scribe confirm the file is on the stick before it erases anything.
// Rejects when the scribe cancels the picker or the write fails, and the caller
// must then erase NOTHING.
export async function saveJsonFile(filename, obj) {
  const picker = globalThis.showSaveFilePicker;
  if (typeof picker === "function") {
    const handle = await picker.call(globalThis, {
      suggestedName: filename,
      types: [{ description: "Sheets file", accept: { "application/json": [".json"] } }],
    });
    const writable = await handle.createWritable();
    try {
      await writable.write(JSON.stringify(obj, null, 2));
    } finally {
      await writable.close();
    }
    return { proven: true };
  }
  triggerJsonDownload(filename, obj);
  return { proven: false };
}
